// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__10mbj","modalForm":"UpgradeEpcsModal_modalForm__2sn43","modalFooter":"UpgradeEpcsModal_modalFooter__Oib5V"};